module.exports = __webpack_public_path__ + "img/brand-stackoverflow.a6cc8d35.svg";